export default {
  container: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    marginBottom: 8,
    paddingBottom: 16,
    paddingLeft: 16,
    paddingRight: 16,
  },
  editButton: {
    height: 28,
    lineHeight: '28px',
  },
  editButtonLabel: {
    fontSize: 12,
    paddingLeft: 6,
  },
  inputCon: {
    width: 120,
    marginLeft: 8,
    marginRight: 8,
    cursor: 'default',
  },
  input: {
    color: 'rgba(0, 0, 0, 0.870588)',
  },
  inputDisabled: {
    borderBottomStyle: 'none',
  },
};



// WEBPACK FOOTER //
// ./src/containers/pay/styles/TaxCard.js